//Libs
import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import { setFeatures } from 'services/local-storage';

//Redux store
import {
  LOAD_FEATURE_LIST,
  LOAD_FEATURE_LIST_SUCCESS,
  LOAD_FEATURE_LIST_ERROR,
} from '../type';

export const initialState = {
  loadingStatus: {
    featureListLoading: false,
  },
  error: '',
  featureList: [],
};

const roleReducer = handleActions(
  new Map([
    [
      LOAD_FEATURE_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            featureListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_FEATURE_LIST_SUCCESS,
      (state, action) => {
        setFeatures(action.payload);
        return update(state, {
          loadingStatus: {
            featureListLoading: { $set: false },
          },
          featureList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_FEATURE_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            featureListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default roleReducer;
